import React from "react";
import Layout from "./Layout";
import usePageMeta from "../hooks/usePageMeta";
import { useAppPermissions } from "../context/PermissionContext";
import RichAuditsPanel from "../components/RichAuditsPanel";
import { AtlasPageHeader, AtlasPageDivider } from "../components/page-layout";

const Audits = () => {
  usePageMeta("Audits");
  const { canWriteAdmin } = useAppPermissions();
  const adminReadOnly = !canWriteAdmin;

  return (
    <Layout active="Audits">
      <fieldset
        disabled={adminReadOnly}
        className="border-0 m-0 p-0 min-w-0 min-h-0"
      >
        <div className="py-3 px-2 flex flex-col min-h-screen">
          <AtlasPageHeader breadcrumb="Admin" title="Audits" showBack={false} className="mb-2" />
          <AtlasPageDivider />

          <div className="mt-6 mx-6 p-4 border-2 border-gray-200 rounded-xl h-full flex flex-col">
            <RichAuditsPanel
              globalList
              embedded
              fetchUrl="/api/audits/rich"
            />
          </div>
        </div>
      </fieldset>
    </Layout>
  );
};

export default Audits;
